export default "__VITE_ASSET__hM$Vf$hA__"